import { Component, Input, Output, EventEmitter, inject } from "@angular/core";

import { CallEvent } from "../../shared/types";
import { PermissionsService } from "../../shared";

@Component({
	selector: "call-event-list",
	templateUrl: "call-event-list.component.html",
	styleUrls: ["call-event-list.component.scss"],
	standalone: false,
})
export class CallEventListComponent {
	private readonly permissionsService = inject(PermissionsService);

	// @ts-expect-error TS2564
	@Input() callEvents: CallEvent[];
	@Output() selectedCallEvent = new EventEmitter<CallEvent>();

	alarmsPermission() {
		return this.permissionsService.userHasPermissions(["MEDAPP.CARE.ADMINISTER_CARE"]);
	}
}
